// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"637b06fb","338":"131039e1","478":"d66d3059","545":"455c8618","559":"da558c6b","573":"637b06fb","841":"d5c75f27","928":"374dbb5e"}[chunkId] + ".chunk.css";
};